var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersSelec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31271 11.3127C7.02153 11.3127 5.15637 9.44751 5.15637 7.15633C5.15637 4.86516 7.02153 3 9.31271 3C11.6039 3 13.469 4.86516 13.469 7.15633C13.469 9.44751 11.6039 11.3127 9.31271 11.3127Z",
    fill: "#EF364E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5237 21.184H4.10167C2.39237 21.184 1 19.7916 1 18.0824C1 14.9235 3.57173 12.3518 6.73055 12.3518H11.8948C15.0536 12.3518 17.6253 14.9235 17.6253 18.0824C17.6253 19.7916 16.233 21.184 14.5237 21.184Z",
    fill: "#EF364E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1941 11.4919C15.6407 11.4919 14.3782 10.2294 14.3782 8.67594C14.3782 7.12251 15.6407 5.85742 17.1941 5.85742C18.7475 5.85742 20.01 7.11991 20.01 8.67334C20.01 10.2268 18.7475 11.4919 17.1941 11.4919Z",
    fill: "#EF364E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5503 18.8461H18.8358L18.7761 18.1317C18.7761 18.1213 19.028 16.7679 18.1448 14.9495C17.2616 13.1311 15.5471 12.3518 15.5471 12.3518H18.9241C21.3166 12.3518 22.9999 14.0065 22.9999 16.399C22.9999 17.7472 21.9011 18.8461 20.5503 18.8461Z",
    fill: "#EF364E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSelec);
export default __webpack_public_path__ + "static/media/usersSelec.de97684f849acd3ba9586ceba7bd9cb9.svg";
export { ForwardRef as ReactComponent };